import { supabase } from './supabase';

export interface OperatingCost {
  id: string;
  business_id: string;
  name: string;
  amount: number;
  type: 'fixed' | 'variable';
  frequency: 'monthly' | 'quarterly' | 'yearly';
  category: string;
  created_at: string;
  updated_at: string;
}

export async function getOperatingCosts(businessId: string) {
  const { data, error } = await supabase
    .from('operating_costs')
    .select('*')
    .eq('business_id', businessId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data as OperatingCost[];
}

export async function createOperatingCost(cost: Omit<OperatingCost, 'id' | 'created_at' | 'updated_at'>) {
  const { data, error } = await supabase
    .from('operating_costs')
    .insert([cost])
    .select()
    .single();

  if (error) throw error;
  return data as OperatingCost;
}

export async function deleteOperatingCost(id: string) {
  const { error } = await supabase
    .from('operating_costs')
    .delete()
    .eq('id', id);

  if (error) throw error;
}